var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceLamp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.6,52.2c-12.2,0-22.1-10-22.1-22.3c0-12.2,9.9-22.1,22.1-22.1s22.2,10,22.2,22.2S42.8,52.2,30.6,52.2z  M30.6,11.8c-10,0-18.1,8.1-18.1,18.1c0,10.1,8.1,18.3,18.1,18.3S48.8,40,48.8,30C48.8,20,40.6,11.8,30.6,11.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.4,46.3c-0.5,0-1-0.2-1.4-0.6c-0.8-0.8-0.8-2,0-2.8l28.5-28.4c0.8-0.8,2-0.8,2.8,0s0.8,2,0,2.8L17.8,45.7 C17.4,46.1,16.9,46.3,16.4,46.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.9,46.2c-0.5,0-1-0.2-1.4-0.6L15.1,17.1c-0.8-0.8-0.8-2,0-2.8s2-0.8,2.8,0l28.4,28.5c0.8,0.8,0.8,2,0,2.8 C45.9,46,45.4,46.2,44.9,46.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceLamp);
export default __webpack_public_path__ + "static/media/device-lamp.b2d9f0d756ffcc99d5581456d6f000f3.svg";
export { ForwardRef as ReactComponent };